import { render } from "./RouterWrapper.vue?vue&type=template&id=acf46a52&ts=true"
import script from "./RouterWrapper.vue?vue&type=script&lang=ts"
export * from "./RouterWrapper.vue?vue&type=script&lang=ts"

import "./RouterWrapper.vue?vue&type=style&index=0&id=acf46a52&lang=sass"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__